<p-toast></p-toast>
<header *ngIf="checkShowheader" class="header header-adisco mb-0" id="header">
  <!-- header top -->
  <div class="header-top">
    <div class="container">
      <div class="header-top-inner d-flex justify-content-between align-items-center">
        <a routerLink="/" class="logo-adisco">
          <img src="src-adisco/assets/images/logo-adisco.png" alt="" />
        </a>
        <a routerLink="/" class="logo-member" *ngIf="logoMember">
          <!-- <img src="src-adisco/assets/images/logo-member.png" alt="" /> -->
          <img [src]="logoMember" alt="" />
        </a>
        <button (click)="showNav()" class="menu-mobile">
          <img src="src-adisco/assets/images/icon/menu-bar.png" alt="" />
        </button>
        <div class="group-link d-flex justify-content-between align-items-center">
          <div *ngIf="userService.hasExtranetAccess('fonctions', 'comparateur-produit')" (mouseover)="addClassOverlay()"
            (mouseout)="delClassOverlay()" class="wrap-comparer">
            <button class="btn-comparator d-flex justify-content-between align-items-center">
              <img src="src-adisco/assets/images/icon/comparator.svg" alt="" />
              <p *ngIf="listProduct.length > 0" class="mb-0 count">{{ listProduct.length }}</p>
              <span class="mb-0">produit(s)</span>
            </button>
            <div class="comparer">
              <div class="comparer-inner">
                <p class="title font-bold mb-1">COMPARATEUR</p>
                <ul class="">
                  <ng-container *ngFor="let item of listProduct">
                    <li class="d-flex justify-content-between align-items-center gap-2">
                      <div class="wrap-img">
                        <img src="{{item?.thumbnailPhoto ? item?.thumbnailPhoto?.[0]?.url : 'src-adisco/assets/images/image-default.jpeg'}}"
                          alt="" />
                      </div>
                      <a href="#">{{ item?.longDescription }}</a>
                      <button class="btn-delete" (click)="delProductToCompare(item)">
                        <img src="src-adisco/assets/images/icon/trash.svg" alt="" />
                      </button>
                    </li>
                  </ng-container>
                </ul>
                <a (click)="compareProduct()" class="btn-common btn-comparer">
                  <img class="non-hover" src="src-adisco/assets/images/icon/comparator-blue.svg" alt="">
                  <img class="hover" src="src-adisco/assets/images/icon/comparator.svg" alt="">
                  COMPARER
                </a>
                
                <ng-container *ngIf="comparatorRepository.loadingCart$ | async">
                  <div class="overlay-loading">
                      <p-progressSpinner
                          styleClass="w-2rem h-2rem"
                          strokeWidth="4"
                          fill="var(--surface-ground)"
                          animationDuration=".5s"
                      ></p-progressSpinner>
                  </div>
              </ng-container>
                
              </div>
            </div>
          </div>
          <a *ngIf="userService.hasExtranetAccess('menu', 'compte')" routerLink="/my-account"
            class="d-flex justify-content-between align-items-center">
            <img src="src-adisco/assets/images/icon/user.svg" alt="" />
            <span>Mon compte</span>
          </a>
          <a *ngIf="userService.hasExtranetAccess('menu', 'deconnexion')" routerLink="/logout"
            class="d-flex justify-content-between align-items-center">
            <img src="src-adisco/assets/images/icon/logout.svg" alt="" />
            <span>Déconnexion</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- navigation -->
  <div [class.active]="isNavActive" class="wrap-nav">
    <div class="container">
      <div class="w-100 wrap-btn-close pt-2">
        <button (click)="hideNav()" class="btn-close">
          <img src="src-adisco/assets/images/icon/close-icon.png" alt="">
        </button>
      </div>
      <div class="nav">
        <ul class="w-100 p-0 mb-0 list-none menu menu-lv1 d-flex justify-content-center align-items-center">
          <li *ngFor="let nav of navOptions"
            (mouseover)="nav.ref === 'catalogues' || nav.ref === 'gestion' ? addClassOverlay() : null"
            (mouseout)="nav.ref === 'catalogues' || nav.ref === 'gestion' ? delClassOverlay() : null" [ngClass]="{
              'active': (nav.ref == 'catalogues' && isMachinesActive) || (nav.ref == 'gestion' && isMachinesActive2),
              'menu-categories': nav.ref === 'catalogues',
              'menu-gestion': nav.ref === 'gestion'
            }" [routerLink]="nav.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
            <a (click)="onRedirectNav(nav.ref)" [ngClass]="nav.ref"
              [routerLink]="(nav.ref === 'fournisseurs' && roleUser === '[Extranet - Fournisseur]') ? nav.route + '/' + codeUser : nav.route">
              {{ nav.title }}
            </a>


            <ng-container *ngIf="nav.subMenuCategory && nav.ref === 'catalogues' && listCategories.length; else elseNoMenu">
              <div class="wrap-menu-lv2">
                <div class="menu menu-lv2">
                  <ul class="list-none p-0 d-flex justify-content-between align-items-center">
                    <ng-container *ngFor="let item of listCategories">
                      <li>
                        <!-- routerLink="/catalogues/{{item.codeCategory}}" -->
                        <a  class="d-flex gap-2 align-items-center" (click)="onClickCategory(item)">
                          <img *ngIf="item?.pictoOfTheCategory[0]?.url" [src]="item.pictoOfTheCategory[0]?.url"
                            alt="" />
                          <img *ngIf="!item?.pictoOfTheCategory[0]?.url"
                            src="src-adisco/assets/images/image-default.jpeg" alt="" />
                          {{ item?.nameCategory?.fr_FR }}
                        </a>
                      </li>
                    </ng-container>
                  </ul>
                 <ng-container *ngIf="loading" >
                  <div class="overlay-loading">
                      <p-progressSpinner
                          styleClass="w-2rem h-2rem"
                          strokeWidth="4"
                          fill="var(--surface-ground)"
                          animationDuration=".5s"
                      ></p-progressSpinner>
                  </div>
              </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-template #elseNoMenu>
              <div class="wrap-menu-lv2">
                <div class="menu menu-lv2">
                  <ul class="list-none p-0 d-flex justify-content-between align-items-center">
                    <div class="overlay-loading">
                      <p-progressSpinner
                          styleClass="w-2rem h-2rem"
                          strokeWidth="4"
                          fill="var(--surface-ground)"
                          animationDuration=".5s"
                      ></p-progressSpinner>
                  </div>
                  </ul>
                </div>
              </div>
              
            </ng-template>
            

            <div *ngIf="nav.subMenuCategory && nav.ref === 'gestion'">
              <div class="wrap-menu-lv2">
                <div class="menu menu-lv2">
                  <ul class="list-none p-0">
                    <li *ngFor="let subNav of nav?.subMenu">
                      <a *ngIf="userService.hasExtranetAccess('menu', subNav.ref)"
                        [routerLink]="subNav.route">{{
                        subNav.title }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- search bar -->
  <div *ngIf="checkedHomepage" class="wrap-search-bar">
    <div class="container outer-search-bar">
      <div class="search-bar d-flex justify-content-between align-items-center">
        <!-- <form [formGroup]="searchForm"> -->
        <div class="wrap-input">
          <label class="mb-0" for="">Rechercher un produit</label>
          <input [(ngModel)]="searchTerm" (keyup)="onSearchInput()" [ngModelOptions]="{standalone: true}"
            (focusout)="emptyList()" (keydown.enter)="submitSearch()" type="text"
            placeholder="Recherche globale sur le catalogue" />
          <div class="autocomplete-list" *ngIf="autocompleteSearchList.length > 0">
            <ul class="p-0" style="list-style: none">
              <li class="ac-li" *ngFor="let item of autocompleteSearchList" (click)="selectItem(item)">
                {{item.referenceProduct}}
                {{item.longDescription ? (item.uniqueId + ' - ' + item.supplierItemNumber + ' - ' + item.longDescription
                + (item.brand ? ' - ' + item.brand : '') ) : ''}}
              </li>
            </ul>
          </div>
        </div>
        <button class="btn-common btn-rechercher" (click)="submitSearch()">
          <span>RECHERCHER</span>
          <img src="src-adisco/assets/images/icon/Icon open-magnifying-glass.svg" alt="">
        </button>
      </div>

      <!-- </form>  -->
    </div>
  </div>
</header>